const DASHBOARD_API_ENDPOINT =  process.env.REACT_APP_DOCUMENT_SIGNING_API_ENDPOINT;

export default {
   
    GET_DASHBOARD_COUNT:                                      DASHBOARD_API_ENDPOINT + "/document/dashboard/count",
    GET_ANALYTICS_COUNT:                                      DASHBOARD_API_ENDPOINT + "/analytics/components"

}